// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lCHX","content":"styles_content__1TJ4J"};